/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum VestingTermTimeUnitType {
    MONTHLY = 'MONTHLY',
    YEARLY = 'YEARLY',
}
